/**
 * Created by zhengyf 2017/8/21
 */

addSubAccountCtrl.$inject = ['$scope', '$timeout', 'request', '$q'];
angular.module('DSSXAPP', ['app.core']);

angular
    .module('DSSXAPP')
    .controller('addSubAccountCtrl', addSubAccountCtrl);

function addSubAccountCtrl($scope, $timeout, request, $q) {

    // ===================variable=========================

    $scope.title = '添加子账号';
    $scope.d = {
        departmentList: [
            {value: 'Director/CEO/General Manager', label: 'Director/CEO/General Manager'},
            {value: 'Sales', label: 'Sales'},
            {value: 'Purchasing', label: 'Purchasing'},
            {value: 'Technical &amp; Engineering', label: 'Technical &amp; Engineering'},
            {value: 'Other', label: 'Other'},
            {value: 'Administrative', label: 'Administrative'},
            {value: 'Marketing', label: 'Marketing'},
            {value: 'Owner/Entrepreneur', label: 'Owner/Entrepreneur'}
        ],
        countryList: [
            {value: 'AF', label: 'Afghanistan'},
            {value: 'ALA', label: 'Aland Islands'},
            {value: 'AL', label: 'Albania'},
            {value: 'GBA', label: 'Alderney'},
            {value: 'DZ', label: 'Algeria'},
            {value: 'AS', label: 'American Samoa'},
            {value: 'AD', label: 'Andorra'},
            {value: 'AO', label: 'Angola'},
            {value: 'AI', label: 'Anguilla'},
            {value: 'AQ', label: 'Antarctica'},
            {value: 'AG', label: 'Antigua and Barbuda'},
            {value: 'AR', label: 'Argentina'},
            {value: 'AM', label: 'Armenia'},
            {value: 'AW', label: 'Aruba'},
            {value: 'ASC', label: 'Ascension Island'},
            {value: 'AU', label: 'Australia'},
            {value: 'AT', label: 'Austria'},
            {value: 'AZ', label: 'Azerbaijan'},
            {value: 'BS', label: 'Bahamas'},
            {value: 'BH', label: 'Bahrain'},
            {value: 'BD', label: 'Bangladesh'},
            {value: 'BB', label: 'Barbados'},
            {value: 'BY', label: 'Belarus'},
            {value: 'BE', label: 'Belgium'},
            {value: 'BZ', label: 'Belize'},
            {value: 'BJ', label: 'Benin'},
            {value: 'BM', label: 'Bermuda'},
            {value: 'BT', label: 'Bhutan'},
            {value: 'BO', label: 'Bolivia'},
            {value: 'BA', label: 'Bosnia and Herzegovina'},
            {value: 'BW', label: 'Botswana'},
            {value: 'BV', label: 'Bouvet Island'},
            {value: 'BR', label: 'Brazil'},
            {value: 'IO', label: 'British Indian Ocean Territory'},
            {value: 'BN', label: 'Brunei Darussalam'},
            {value: 'BG', label: 'Bulgaria'},
            {value: 'BF', label: 'Burkina Faso'},
            {value: 'BI', label: 'Burundi'},
            {value: 'KH', label: 'Cambodia'},
            {value: 'CM', label: 'Cameroon'},
            {value: 'CA', label: 'Canada'},
            {value: 'CV', label: 'Cape Verde'},
            {value: 'KY', label: 'Cayman Islands'},
            {value: 'CF', label: 'Central African Republic'},
            {value: 'TD', label: 'Chad'},
            {value: 'CL', label: 'Chile'},
            {value: 'CN', label: 'China (Mainland)'},
            {value: 'CX', label: 'Christmas Island'},
            {value: 'CC', label: 'Cocos (Keeling) Islands'},
            {value: 'CO', label: 'Colombia'},
            {value: 'KM', label: 'Comoros'},
            {value: 'ZR', label: 'Congo, The Democratic Republic Of The'},
            {value: 'CG', label: 'Congo, The Republic of Congo'},
            {value: 'CK', label: 'Cook Islands'},
            {value: 'CR', label: 'Costa Rica'},
            {value: 'CI', label: 'Cote D&#39;Ivoire'},
            {value: 'HR', label: 'Croatia (local name: Hrvatska)'},
            {value: 'CU', label: 'Cuba'},
            {value: 'CY', label: 'Cyprus'},
            {value: 'CZ', label: 'Czech Republic'},
            {value: 'DK', label: 'Denmark'},
            {value: 'DJ', label: 'Djibouti'},
            {value: 'DM', label: 'Dominica'},
            {value: 'DO', label: 'Dominican Republic'},
            {value: 'TP', label: 'East Timor'},
            {value: 'EC', label: 'Ecuador'},
            {value: 'EG', label: 'Egypt'},
            {value: 'SV', label: 'El Salvador'},
            {value: 'GQ', label: 'Equatorial Guinea'},
            {value: 'ER', label: 'Eritrea'},
            {value: 'EE', label: 'Estonia'},
            {value: 'ET', label: 'Ethiopia'},
            {value: 'FK', label: 'Falkland Islands (Malvinas)'},
            {value: 'FO', label: 'Faroe Islands'},
            {value: 'FJ', label: 'Fiji'},
            {value: 'FI', label: 'Finland'},
            {value: 'FR', label: 'France'},
            {value: 'FX', label: 'France Metropolitan'},
            {value: 'GF', label: 'French Guiana'},
            {value: 'PF', label: 'French Polynesia'},
            {value: 'TF', label: 'French Southern Territories'},
            {value: 'GA', label: 'Gabon'},
            {value: 'GM', label: 'Gambia'},
            {value: 'GE', label: 'Georgia'},
            {value: 'DE', label: 'Germany'},
            {value: 'GH', label: 'Ghana'},
            {value: 'GI', label: 'Gibraltar'},
            {value: 'GR', label: 'Greece'},
            {value: 'GL', label: 'Greenland'},
            {value: 'GD', label: 'Grenada'},
            {value: 'GP', label: 'Guadeloupe'},
            {value: 'GU', label: 'Guam'},
            {value: 'GT', label: 'Guatemala'},
            {value: 'GGY', label: 'Guernsey'},
            {value: 'GN', label: 'Guinea'},
            {value: 'GW', label: 'Guinea-Bissau'},
            {value: 'GY', label: 'Guyana'},
            {value: 'HT', label: 'Haiti'},
            {value: 'HM', label: 'Heard and Mc Donald Islands'},
            {value: 'HN', label: 'Honduras'},
            {value: 'HK', label: 'Hong Kong'},
            {value: 'HU', label: 'Hungary'},
            {value: 'IS', label: 'Iceland'},
            {value: 'IN', label: 'India'},
            {value: 'ID', label: 'Indonesia'},
            {value: 'IR', label: 'Iran (Islamic Republic of)'},
            {value: 'IQ', label: 'Iraq'},
            {value: 'IE', label: 'Ireland'},
            {value: 'IM', label: 'Isle of Man'},
            {value: 'IL', label: 'Israel'},
            {value: 'IT', label: 'Italy'},
            {value: 'JM', label: 'Jamaica'},
            {value: 'JP', label: 'Japan'},
            {value: 'JEY', label: 'Jersey'},
            {value: 'JO', label: 'Jordan'},
            {value: 'KZ', label: 'Kazakhstan'},
            {value: 'KE', label: 'Kenya'},
            {value: 'KI', label: 'Kiribati'},
            {value: 'KS', label: 'Kosovo'},
            {value: 'KW', label: 'Kuwait'},
            {value: 'KG', label: 'Kyrgyzstan'},
            {value: 'LA', label: 'Lao People&#39;s Democratic Republic'},
            {value: 'LV', label: 'Latvia'},
            {value: 'LB', label: 'Lebanon'},
            {value: 'LS', label: 'Lesotho'},
            {value: 'LR', label: 'Liberia'},
            {value: 'LY', label: 'Libya'},
            {value: 'LI', label: 'Liechtenstein'},
            {value: 'LT', label: 'Lithuania'},
            {value: 'LU', label: 'Luxembourg'},
            {value: 'MO', label: 'Macau'},
            {value: 'MK', label: 'Macedonia'},
            {value: 'MG', label: 'Madagascar'},
            {value: 'MW', label: 'Malawi'},
            {value: 'MY', label: 'Malaysia'},
            {value: 'MV', label: 'Maldives'},
            {value: 'ML', label: 'Mali'},
            {value: 'MT', label: 'Malta'},
            {value: 'MH', label: 'Marshall Islands'},
            {value: 'MQ', label: 'Martinique'},
            {value: 'MR', label: 'Mauritania'},
            {value: 'MU', label: 'Mauritius'},
            {value: 'YT', label: 'Mayotte'},
            {value: 'MX', label: 'Mexico'},
            {value: 'FM', label: 'Micronesia'},
            {value: 'MD', label: 'Moldova'},
            {value: 'MC', label: 'Monaco'},
            {value: 'MN', label: 'Mongolia'},
            {value: 'MNE', label: 'Montenegro'},
            {value: 'MS', label: 'Montserrat'},
            {value: 'MA', label: 'Morocco'},
            {value: 'MZ', label: 'Mozambique'},
            {value: 'MM', label: 'Myanmar'},
            {value: 'NA', label: 'Namibia'},
            {value: 'NR', label: 'Nauru'},
            {value: 'NP', label: 'Nepal'},
            {value: 'NL', label: 'Netherlands'},
            {value: 'AN', label: 'Netherlands Antilles'},
            {value: 'NC', label: 'New Caledonia'},
            {value: 'NZ', label: 'New Zealand'},
            {value: 'NI', label: 'Nicaragua'},
            {value: 'NE', label: 'Niger'},
            {value: 'NG', label: 'Nigeria'},
            {value: 'NU', label: 'Niue'},
            {value: 'NF', label: 'Norfolk Island'},
            {value: 'KP', label: 'North Korea'},
            {value: 'MP', label: 'Northern Mariana Islands'},
            {value: 'NO', label: 'Norway'},
            {value: 'OM', label: 'Oman'},
            {value: 'Other', label: 'Other Country'},
            {value: 'PK', label: 'Pakistan'},
            {value: 'PW', label: 'Palau'},
            {value: 'PS', label: 'Palestine'},
            {value: 'PA', label: 'Panama'},
            {value: 'PG', label: 'Papua New Guinea'},
            {value: 'PY', label: 'Paraguay'},
            {value: 'PE', label: 'Peru'},
            {value: 'PH', label: 'Philippines'},
            {value: 'PN', label: 'Pitcairn'},
            {value: 'PL', label: 'Poland'},
            {value: 'PT', label: 'Portugal'},
            {value: 'PR', label: 'Puerto Rico'},
            {value: 'QA', label: 'Qatar'},
            {value: 'RE', label: 'Reunion'},
            {value: 'RO', label: 'Romania'},
            {value: 'RU', label: 'Russian Federation'},
            {value: 'RW', label: 'Rwanda'},
            {value: 'BLM', label: 'Saint Barthelemy'},
            {value: 'KN', label: 'Saint Kitts and Nevis'},
            {value: 'LC', label: 'Saint Lucia'},
            {value: 'MAF', label: 'Saint Martin'},
            {value: 'VC', label: 'Saint Vincent and the Grenadines'},
            {value: 'WS', label: 'Samoa'},
            {value: 'SM', label: 'San Marino'},
            {value: 'ST', label: 'Sao Tome and Principe'},
            {value: 'SA', label: 'Saudi Arabia'},
            {value: 'SCT', label: 'Scotland'},
            {value: 'SN', label: 'Senegal'},
            {value: 'SRB', label: 'Serbia'},
            {value: 'SC', label: 'Seychelles'},
            {value: 'SL', label: 'Sierra Leone'},
            {value: 'SG', label: 'Singapore'},
            {value: 'SK', label: 'Slovakia (Slovak Republic)'},
            {value: 'SI', label: 'Slovenia'},
            {value: 'SB', label: 'Solomon Islands'},
            {value: 'SO', label: 'Somalia'},
            {value: 'ZA', label: 'South Africa'},
            {value: 'SGS', label: 'South Georgia and the South Sandwich Islands'},
            {value: 'KR', label: 'South Korea'},
            {value: 'SS', label: 'South Sudan'},
            {value: 'ES', label: 'Spain'},
            {value: 'LK', label: 'Sri Lanka'},
            {value: 'SH', label: 'St. Helena'},
            {value: 'PM', label: 'St. Pierre and Miquelon'},
            {value: 'SD', label: 'Sudan'},
            {value: 'SR', label: 'Suriname'},
            {value: 'SJ', label: 'Svalbard and Jan Mayen Islands'},
            {value: 'SZ', label: 'Swaziland'},
            {value: 'SE', label: 'Sweden'},
            {value: 'CH', label: 'Switzerland'},
            {value: 'SY', label: 'Syrian Arab Republic'},
            {value: 'TW', label: 'Taiwan'},
            {value: 'TJ', label: 'Tajikistan'},
            {value: 'TZ', label: 'Tanzania'},
            {value: 'TH', label: 'Thailand'},
            {value: 'TLS', label: 'Timor-Leste'},
            {value: 'TG', label: 'Togo'},
            {value: 'TK', label: 'Tokelau'},
            {value: 'TO', label: 'Tonga'},
            {value: 'TT', label: 'Trinidad and Tobago'},
            {value: 'TN', label: 'Tunisia'},
            {value: 'TR', label: 'Turkey'},
            {value: 'TM', label: 'Turkmenistan'},
            {value: 'TC', label: 'Turks and Caicos Islands'},
            {value: 'TV', label: 'Tuvalu'},
            {value: 'UG', label: 'Uganda'},
            {value: 'UA', label: 'Ukraine'},
            {value: 'AE', label: 'United Arab Emirates'},
            {value: 'UK', label: 'United Kingdom'},
            {value: 'US', label: 'United States'},
            {value: 'UM', label: 'United States Minor Outlying Islands'},
            {value: 'UY', label: 'Uruguay'},
            {value: 'UZ', label: 'Uzbekistan'},
            {value: 'VU', label: 'Vanuatu'},
            {value: 'VA', label: 'Vatican City State (Holy See)'},
            {value: 'VE', label: 'Venezuela'},
            {value: 'VN', label: 'Vietnam'},
            {value: 'VG', label: 'Virgin Islands (British)'},
            {value: 'VI', label: 'Virgin Islands (U.S.)'},
            {value: 'WF', label: 'Wallis And Futuna Islands'},
            {value: 'EH', label: 'Western Sahara'},
            {value: 'YE', label: 'Yemen'},
            {value: 'YU', label: 'Yugoslavia'},
            {value: 'ZM', label: 'Zambia'},
            {value: 'EAZ', label: 'Zanzibar'},
            {value: 'ZW', label: 'Zimbabwe'},
            {value: 'CW', label: 'Curacao'},
            {value: 'SX', label: 'Sint Maarten'}
        ],
        provinceMap: {
            CN: [
                {value: 'Anhui', label: 'Anhui'},
                {value: 'Beijing', label: 'Beijing'},
                {value: 'Chongqing', label: 'Chongqing'},
                {value: 'Fujian', label: 'Fujian'},
                {value: 'Gansu', label: 'Gansu'},
                {value: 'Guangdong', label: 'Guangdong'},
                {value: 'Guangxi', label: 'Guangxi'},
                {value: 'Guizhou', label: 'Guizhou'},
                {value: 'Hainan', label: 'Hainan'},
                {value: 'Hebei', label: 'Hebei'},
                {value: 'Heilongjiang', label: 'Heilongjiang'},
                {value: 'Henan', label: 'Henan'},
                {value: 'Hubei', label: 'Hubei'},
                {value: 'Hunan', label: 'Hunan'},
                {value: 'Jiangsu', label: 'Jiangsu'},
                {value: 'Jiangxi', label: 'Jiangxi'},
                {value: 'Jilin', label: 'Jilin'},
                {value: 'Liaoning', label: 'Liaoning'},
                {value: 'Inner Mongolia', label: 'Inner Mongolia'},
                {value: 'Ningxia', label: 'Ningxia'},
                {value: 'Qinghai', label: 'Qinghai'},
                {value: 'Shaanxi', label: 'Shaanxi'},
                {value: 'Shandong', label: 'Shandong'},
                {value: 'Shanghai', label: 'Shanghai'},
                {value: 'Shanxi', label: 'Shanxi'},
                {value: 'Sichuan', label: 'Sichuan'},
                {value: 'Tianjin', label: 'Tianjin'},
                {value: 'Xinjiang', label: 'Xinjiang'},
                {value: 'Tibet', label: 'Tibet'},
                {value: 'Yunnan', label: 'Yunnan'},
                {value: 'Zhejiang', label: 'Zhejiang'},
            ],
            KR: [
                {value: 'Busan', label: 'Busan'},
                {value: 'Chungcheongbuk-do', label: 'Chungcheongbuk-do'},
                {value: 'Chungcheongnam-do', label: 'Chungcheongnam-do'},
                {value: 'Daegu', label: 'Daegu'},
                {value: 'Daejeon', label: 'Daejeon'},
                {value: 'Gangwon-do', label: 'Gangwon-do'},
                {value: 'Gwangju', label: 'Gwangju'},
                {value: 'Gyeonggi-do', label: 'Gyeonggi-do'},
                {value: 'Gyeongsangbuk-do', label: 'Gyeongsangbuk-do'},
                {value: 'Gyeongsangnam-do', label: 'Gyeongsangnam-do'},
                {value: 'Incheon', label: 'Incheon'},
                {value: 'Jeju-do', label: 'Jeju-do'},
                {value: 'Jeollabuk-do', label: 'Jeollabuk-do'},
                {value: 'Jeollanam-do', label: 'Jeollanam-do'},
                {value: 'Seoul', label: 'Seoul'},
                {value: 'Ulsan', label: 'Ulsan'},
                {value: 'Sejong', label: 'Sejong'},
            ],
            US: [
                {value: 'Alabama', label: 'Alabama'},
                {value: 'Alaska', label: 'Alaska'},
                {value: 'Arizona', label: 'Arizona'},
                {value: 'Arkansas', label: 'Arkansas'},
                {value: 'California', label: 'California'},
                {value: 'Colorado', label: 'Colorado'},
                {value: 'Connecticut', label: 'Connecticut'},
                {value: 'Delaware', label: 'Delaware'},
                {value: 'District of Columbia', label: 'District of Columbia'},
                {value: 'Florida', label: 'Florida'},
                {value: 'Georgia', label: 'Georgia'},
                {value: 'Hawaii', label: 'Hawaii'},
                {value: 'Idaho', label: 'Idaho'},
                {value: 'Illinois', label: 'Illinois'},
                {value: 'Indiana', label: 'Indiana'},
                {value: 'Iowa', label: 'Iowa'},
                {value: 'Kansas', label: 'Kansas'},
                {value: 'Kentucky', label: 'Kentucky'},
                {value: 'Louisiana', label: 'Louisiana'},
                {value: 'Maine', label: 'Maine'},
                {value: 'Maryland', label: 'Maryland'},
                {value: 'Massachusetts', label: 'Massachusetts'},
                {value: 'Michigan', label: 'Michigan'},
                {value: 'Minnesota', label: 'Minnesota'},
                {value: 'Mississippi', label: 'Mississippi'},
                {value: 'Missouri', label: 'Missouri'},
                {value: 'Montana', label: 'Montana'},
                {value: 'Nebraska', label: 'Nebraska'},
                {value: 'Nevada', label: 'Nevada'},
                {value: 'New Hampshire', label: 'New Hampshire'},
                {value: 'New Jersey', label: 'New Jersey'},
                {value: 'New Mexico', label: 'New Mexico'},
                {value: 'New York', label: 'New York'},
                {value: 'North Carolina', label: 'North Carolina'},
                {value: 'North Dakota', label: 'North Dakota'},
                {value: 'Ohio', label: 'Ohio'},
                {value: 'Oklahoma', label: 'Oklahoma'},
                {value: 'Oregon', label: 'Oregon'},
                {value: 'Pennsylvania', label: 'Pennsylvania'},
                {value: 'Rhode Island', label: 'Rhode Island'},
                {value: 'South Carolina', label: 'South Carolina'},
                {value: 'South Dakota', label: 'South Dakota'},
                {value: 'Tennessee', label: 'Tennessee'},
                {value: 'Texas', label: 'Texas'},
                {value: 'Utah', label: 'Utah'},
                {value: 'Vermont', label: 'Vermont'},
                {value: 'Virginia', label: 'Virginia'},
                {value: 'Washington', label: 'Washington'},
                {value: 'West Virginia', label: 'West Virginia'},
                {value: 'Wisconsin', label: 'Wisconsin'},
                {value: 'Wyoming', label: 'Wyoming'},
            ],
            UK: [
                {value: 'Aberdeenshire', label: 'Aberdeenshire'},
                {value: 'Angus', label: 'Angus'},
                {value: 'Argyll', label: 'Argyll'},
                {value: 'Avon', label: 'Avon'},
                {value: 'Ayrshire', label: 'Ayrshire'},
                {value: 'Banffshire', label: 'Banffshire'},
                {value: 'Bedfordshire', label: 'Bedfordshire'},
                {value: 'Berkshire', label: 'Berkshire'},
                {value: 'Berwickshire', label: 'Berwickshire'},
                {value: 'Buckinghamshire', label: 'Buckinghamshire'},
                {value: 'Caerphilly', label: 'Caerphilly'},
                {value: 'Caithness', label: 'Caithness'},
                {value: 'Cambridgeshire', label: 'Cambridgeshire'},
                {value: 'Cardiff', label: 'Cardiff'},
                {value: 'Carmarthenshire', label: 'Carmarthenshire'},
                {value: 'Cheshire', label: 'Cheshire'},
                {value: 'Clackmannanshire', label: 'Clackmannanshire'},
                {value: 'Cleveland', label: 'Cleveland'},
                {value: 'Clwyd', label: 'Clwyd'},
                {value: 'Cornwall', label: 'Cornwall'},
                {value: 'County Antrim', label: 'County Antrim'},
                {value: 'County Armagh', label: 'County Armagh'},
                {value: 'County Down', label: 'County Down'},
                {value: 'County Durham', label: 'County Durham'},
                {value: 'County Fermanagh', label: 'County Fermanagh'},
                {value: 'County Londonderry', label: 'County Londonderry'},
                {value: 'County Tyrone', label: 'County Tyrone'},
                {value: 'Cumbria', label: 'Cumbria'},
                {value: 'Derbyshire', label: 'Derbyshire'},
                {value: 'Devon', label: 'Devon'},
                {value: 'Dorset', label: 'Dorset'},
                {value: 'Dumfriesshire', label: 'Dumfriesshire'},
                {value: 'Dunbartonshire', label: 'Dunbartonshire'},
                {value: 'Dyfed', label: 'Dyfed'},
                {value: 'East Lothian', label: 'East Lothian'},
                {value: 'East Sussex', label: 'East Sussex'},
                {value: 'Essex', label: 'Essex'},
                {value: 'Fife', label: 'Fife'},
                {value: 'Glasgow', label: 'Glasgow'},
                {value: 'Gloucestershire', label: 'Gloucestershire'},
                {value: 'Greater Manchester', label: 'Greater Manchester'},
                {value: 'Guernsey', label: 'Guernsey'},
                {value: 'Gwent', label: 'Gwent'},
                {value: 'Gwynedd', label: 'Gwynedd'},
                {value: 'Hampshire', label: 'Hampshire'},
                {value: 'Herefordshire', label: 'Herefordshire'},
                {value: 'Hertfordshire', label: 'Hertfordshire'},
                {value: 'Inverness-Shire', label: 'Inverness-Shire'},
                {value: 'Isle Of Arran', label: 'Isle Of Arran'},
                {value: 'Isle Of Barra', label: 'Isle Of Barra'},
                {value: 'Isle Of Benbecula', label: 'Isle Of Benbecula'},
                {value: 'Isle Of Bute', label: 'Isle Of Bute'},
                {value: 'Isle Of Canna', label: 'Isle Of Canna'},
                {value: 'Isle Of Coll', label: 'Isle Of Coll'},
                {value: 'Isle Of Colonsay', label: 'Isle Of Colonsay'},
                {value: 'Isle Of Cumbrae', label: 'Isle Of Cumbrae'},
                {value: 'Isle Of Eigg', label: 'Isle Of Eigg'},
                {value: 'Isle Of Gigha', label: 'Isle Of Gigha'},
                {value: 'Isle Of Harris', label: 'Isle Of Harris'},
                {value: 'Isle Of Iona', label: 'Isle Of Iona'},
                {value: 'Isle Of Islay', label: 'Isle Of Islay'},
                {value: 'Isle Of Jura', label: 'Isle Of Jura'},
                {value: 'Isle Of Lewis', label: 'Isle Of Lewis'},
                {value: 'Isle Of Mull', label: 'Isle Of Mull'},
                {value: 'Isle Of North Uist', label: 'Isle Of North Uist'},
                {value: 'Isle Of Rum', label: 'Isle Of Rum'},
                {value: 'Isle Of Scalpay', label: 'Isle Of Scalpay'},
                {value: 'Isle Of Skye', label: 'Isle Of Skye'},
                {value: 'Isle Of South Uist', label: 'Isle Of South Uist'},
                {value: 'Isle Of Tiree', label: 'Isle Of Tiree'},
                {value: 'Isle Of Wight', label: 'Isle Of Wight'},
                {value: 'Isles Of Scilly', label: 'Isles Of Scilly'},
                {value: 'Jersey', label: 'Jersey'},
                {value: 'Kent', label: 'Kent'},
                {value: 'Kincardineshire', label: 'Kincardineshire'},
                {value: 'Kinross-Shire', label: 'Kinross-Shire'},
                {value: 'Kirkcudbrightshire', label: 'Kirkcudbrightshire'},
                {value: 'Lanarkshire', label: 'Lanarkshire'},
                {value: 'Lancashire', label: 'Lancashire'},
                {value: 'Leicestershire', label: 'Leicestershire'},
                {value: 'Lincolnshire', label: 'Lincolnshire'},
                {value: 'London', label: 'London'},
                {value: 'Merseyside', label: 'Merseyside'},
                {value: 'Mid Glamorgan', label: 'Mid Glamorgan'},
                {value: 'Middlesex', label: 'Middlesex'},
                {value: 'Midlothian', label: 'Midlothian'},
                {value: 'Morayshire', label: 'Morayshire'},
                {value: 'Nairnshire', label: 'Nairnshire'},
                {value: 'Newport', label: 'Newport'},
                {value: 'Norfolk', label: 'Norfolk'},
                {value: 'North Humberside', label: 'North Humberside'},
                {value: 'North Yorkshire', label: 'North Yorkshire'},
                {value: 'Northamptonshire', label: 'Northamptonshire'},
                {value: 'Northumberland', label: 'Northumberland'},
                {value: 'Nottinghamshire', label: 'Nottinghamshire'},
                {value: 'Orkney Isles', label: 'Orkney Isles'},
                {value: 'Oxfordshire', label: 'Oxfordshire'},
                {value: 'Peeblesshire', label: 'Peeblesshire'},
                {value: 'Pembrokeshire', label: 'Pembrokeshire'},
                {value: 'Perthshire', label: 'Perthshire'},
                {value: 'Powys', label: 'Powys'},
                {value: 'Renfrewshire', label: 'Renfrewshire'},
                {value: 'Ross-Shire', label: 'Ross-Shire'},
                {value: 'Roxburghshire', label: 'Roxburghshire'},
                {value: 'Rutland', label: 'Rutland'},
                {value: 'Selkirkshire', label: 'Selkirkshire'},
                {value: 'Shetland Islands', label: 'Shetland Islands'},
                {value: 'Shropshire', label: 'Shropshire'},
                {value: 'Somerset', label: 'Somerset'},
                {value: 'South Glamorgan', label: 'South Glamorgan'},
                {value: 'South Humberside', label: 'South Humberside'},
                {value: 'South Yorkshire', label: 'South Yorkshire'},
                {value: 'Staffordshire', label: 'Staffordshire'},
                {value: 'Stirlingshire', label: 'Stirlingshire'},
                {value: 'Suffolk', label: 'Suffolk'},
                {value: 'Surrey', label: 'Surrey'},
                {value: 'Sutherland', label: 'Sutherland'},
                {value: 'Tyne And Wear', label: 'Tyne And Wear'},
                {value: 'Warwickshire', label: 'Warwickshire'},
                {value: 'West Glamorgan', label: 'West Glamorgan'},
                {value: 'West Lothian', label: 'West Lothian'},
                {value: 'West Midlands', label: 'West Midlands'},
                {value: 'West Sussex', label: 'West Sussex'},
                {value: 'West Yorkshire', label: 'West Yorkshire'},
                {value: 'Wigtownshire', label: 'Wigtownshire'},
                {value: 'Wiltshire', label: 'Wiltshire'},
                {value: 'Worcestershire', label: 'Worcestershire'},
            ],
            IN: [
                {value: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands'},
                {value: 'Andhra Pradesh', label: 'Andhra Pradesh'},
                {value: 'Arunachal Pradesh', label: 'Arunachal Pradesh'},
                {value: 'Assam', label: 'Assam'},
                {value: 'Bihar', label: 'Bihar'},
                {value: 'Chandigarh', label: 'Chandigarh'},
                {value: 'Chhattisgarh', label: 'Chhattisgarh'},
                {value: 'Dadra and Nagar Haveli', label: 'Dadra and Nagar Haveli'},
                {value: 'Daman and Diu', label: 'Daman and Diu'},
                {value: 'Delhi', label: 'Delhi'},
                {value: 'Goa', label: 'Goa'},
                {value: 'Gujarat', label: 'Gujarat'},
                {value: 'Haryana', label: 'Haryana'},
                {value: 'Himachal Pradesh', label: 'Himachal Pradesh'},
                {value: 'Jammu and Kashmir', label: 'Jammu and Kashmir'},
                {value: 'Jharkhand', label: 'Jharkhand'},
                {value: 'Karnataka', label: 'Karnataka'},
                {value: 'Kerala', label: 'Kerala'},
                {value: 'Lakshadweep', label: 'Lakshadweep'},
                {value: 'Madhya Pradesh', label: 'Madhya Pradesh'},
                {value: 'Maharashtra', label: 'Maharashtra'},
                {value: 'Manipur', label: 'Manipur'},
                {value: 'Meghalaya', label: 'Meghalaya'},
                {value: 'Mizoram', label: 'Mizoram'},
                {value: 'Nagaland', label: 'Nagaland'},
                {value: 'Orissa', label: 'Orissa'},
                {value: 'Puducherry', label: 'Puducherry'},
                {value: 'Punjab', label: 'Punjab'},
                {value: 'Rajasthan', label: 'Rajasthan'},
                {value: 'Sikkim', label: 'Sikkim'},
                {value: 'Tamil Nadu', label: 'Tamil Nadu'},
                {value: 'Tripura', label: 'Tripura'},
                {value: 'Uttar Pradesh', label: 'Uttar Pradesh'},
                {value: 'Uttarakhand', label: 'Uttarakhand'},
                {value: 'West Bengal', label: 'West Bengal'},
                {value: 'Telangana', label: 'Telangana'},
            ],
            TR: [
                {value: 'Adana', label: 'Adana'},
                {value: 'Adiyaman', label: 'Adiyaman'},
                {value: 'Afyonkarahisar', label: 'Afyonkarahisar'},
                {value: 'Agri', label: 'Agri'},
                {value: 'Aksaray', label: 'Aksaray'},
                {value: 'Amasya', label: 'Amasya'},
                {value: 'Ankara', label: 'Ankara'},
                {value: 'Antalya', label: 'Antalya'},
                {value: 'Ardahan', label: 'Ardahan'},
                {value: 'Artvin', label: 'Artvin'},
                {value: 'Aydin', label: 'Aydin'},
                {value: 'Balikesir', label: 'Balikesir'},
                {value: 'Bartin', label: 'Bartin'},
                {value: 'Batman', label: 'Batman'},
                {value: 'Bayburt', label: 'Bayburt'},
                {value: 'Bilecik', label: 'Bilecik'},
                {value: 'Bingol', label: 'Bingol'},
                {value: 'Bitlis', label: 'Bitlis'},
                {value: 'Bolu', label: 'Bolu'},
                {value: 'Burdur', label: 'Burdur'},
                {value: 'Bursa', label: 'Bursa'},
                {value: 'Canakkale', label: 'Canakkale'},
                {value: 'Cankiri', label: 'Cankiri'},
                {value: 'Corum', label: 'Corum'},
                {value: 'Denizli', label: 'Denizli'},
                {value: 'Diyarbakir', label: 'Diyarbakir'},
                {value: 'Duzce', label: 'Duzce'},
                {value: 'Edirne', label: 'Edirne'},
                {value: 'Elazig', label: 'Elazig'},
                {value: 'Erzincan', label: 'Erzincan'},
                {value: 'Erzurum', label: 'Erzurum'},
                {value: 'Eskisehir', label: 'Eskisehir'},
                {value: 'Gaziantep', label: 'Gaziantep'},
                {value: 'Giresun', label: 'Giresun'},
                {value: 'Gumushane', label: 'Gumushane'},
                {value: 'Hakkari', label: 'Hakkari'},
                {value: 'Hatay', label: 'Hatay'},
                {value: 'Igdir', label: 'Igdir'},
                {value: 'Isparta', label: 'Isparta'},
                {value: 'Istanbul', label: 'Istanbul'},
                {value: 'Izmir', label: 'Izmir'},
                {value: 'Kahramanmaras', label: 'Kahramanmaras'},
                {value: 'Karabuk', label: 'Karabuk'},
                {value: 'Karaman', label: 'Karaman'},
                {value: 'Kars', label: 'Kars'},
                {value: 'Kastamonu', label: 'Kastamonu'},
                {value: 'Kayseri', label: 'Kayseri'},
                {value: 'Kilis', label: 'Kilis'},
                {value: 'Kirikkale', label: 'Kirikkale'},
                {value: 'Kirklareli', label: 'Kirklareli'},
                {value: 'Kirsehir', label: 'Kirsehir'},
                {value: 'Kocaeli', label: 'Kocaeli'},
                {value: 'Konya', label: 'Konya'},
                {value: 'Kutahya', label: 'Kutahya'},
                {value: 'Malatya', label: 'Malatya'},
                {value: 'Manisa', label: 'Manisa'},
                {value: 'Mardin', label: 'Mardin'},
                {value: 'Mersin', label: 'Mersin'},
                {value: 'Mugla', label: 'Mugla'},
                {value: 'Mus', label: 'Mus'},
                {value: 'Nevsehir', label: 'Nevsehir'},
                {value: 'Nigde', label: 'Nigde'},
                {value: 'Ordu', label: 'Ordu'},
                {value: 'Osmaniye', label: 'Osmaniye'},
                {value: 'Rize', label: 'Rize'},
                {value: 'Sakarya', label: 'Sakarya'},
                {value: 'Samsun', label: 'Samsun'},
                {value: 'Sanliurfa', label: 'Sanliurfa'},
                {value: 'Siirt', label: 'Siirt'},
                {value: 'Sinop', label: 'Sinop'},
                {value: 'Sirnak', label: 'Sirnak'},
                {value: 'Sivas', label: 'Sivas'},
                {value: 'Tekirdag', label: 'Tekirdag'},
                {value: 'Tokat', label: 'Tokat'},
                {value: 'Trabzon', label: 'Trabzon'},
                {value: 'Tunceli', label: 'Tunceli'},
                {value: 'Usak', label: 'Usak'},
                {value: 'Van', label: 'Van'},
                {value: 'Yalova', label: 'Yalova'},
                {value: 'Yozgat', label: 'Yozgat'},
                {value: 'Zonguldak', label: 'Zonguldak'},
            ],
            MY: [
                {value: 'Johor', label: 'Johor'},
                {value: 'Kedah', label: 'Kedah'},
                {value: 'Kelantan', label: 'Kelantan'},
                {value: 'Kuala Lumpur', label: 'Kuala Lumpur'},
                {value: 'Labuan', label: 'Labuan'},
                {value: 'Melaka', label: 'Melaka'},
                {value: 'Negeri Sembilan', label: 'Negeri Sembilan'},
                {value: 'Nilai', label: 'Nilai'},
                {value: 'Pahang', label: 'Pahang'},
                {value: 'Perak', label: 'Perak'},
                {value: 'Perlis', label: 'Perlis'},
                {value: 'Pulau Pinang', label: 'Pulau Pinang'},
                {value: 'Putrajaya', label: 'Putrajaya'},
                {value: 'Sabah', label: 'Sabah'},
                {value: 'Sarawak', label: 'Sarawak'},
                {value: 'Selangor', label: 'Selangor'},
                {value: 'Terengganu', label: 'Terengganu'},
            ],
            VN: [
                {value: 'An Giang', label: 'An Giang'},
                {value: 'Ba Ria-Vung Tau', label: 'Ba Ria-Vung Tau'},
                {value: 'Bac Giang', label: 'Bac Giang'},
                {value: 'Bac Kan', label: 'Bac Kan'},
                {value: 'Bac Lieu', label: 'Bac Lieu'},
                {value: 'Bac Ninh', label: 'Bac Ninh'},
                {value: 'Ben Tre', label: 'Ben Tre'},
                {value: 'Binh Dinh', label: 'Binh Dinh'},
                {value: 'Binh Duong', label: 'Binh Duong'},
                {value: 'Binh Phuoc', label: 'Binh Phuoc'},
                {value: 'Binh Thuan', label: 'Binh Thuan'},
                {value: 'Ca Mau', label: 'Ca Mau'},
                {value: 'Can Tho', label: 'Can Tho'},
                {value: 'Cao Bang', label: 'Cao Bang'},
                {value: 'Da Nang', label: 'Da Nang'},
                {value: 'Dak Lak', label: 'Dak Lak'},
                {value: 'Dak Nong', label: 'Dak Nong'},
                {value: 'Dien Bien', label: 'Dien Bien'},
                {value: 'Dong Nai', label: 'Dong Nai'},
                {value: 'Dong Thap', label: 'Dong Thap'},
                {value: 'Gia Lai', label: 'Gia Lai'},
                {value: 'Ha Giang', label: 'Ha Giang'},
                {value: 'Ha Nam', label: 'Ha Nam'},
                {value: 'Hanoi', label: 'Hanoi'},
                {value: 'Ha Tinh', label: 'Ha Tinh'},
                {value: 'Hai Duong', label: 'Hai Duong'},
                {value: 'Hai Phong', label: 'Hai Phong'},
                {value: 'Ho Chi Minh City', label: 'Ho Chi Minh City'},
                {value: 'Hau Giang', label: 'Hau Giang'},
                {value: 'Hoa Binh', label: 'Hoa Binh'},
                {value: 'Hung Yen', label: 'Hung Yen'},
                {value: 'Khanh Hoa', label: 'Khanh Hoa'},
                {value: 'Kien Giang', label: 'Kien Giang'},
                {value: 'Kon Tum', label: 'Kon Tum'},
                {value: 'Lai Chau', label: 'Lai Chau'},
                {value: 'Lam Dong', label: 'Lam Dong'},
                {value: 'Lang Son', label: 'Lang Son'},
                {value: 'Lao Cai', label: 'Lao Cai'},
                {value: 'Long An', label: 'Long An'},
                {value: 'Nam Dinh', label: 'Nam Dinh'},
                {value: 'Nghe An', label: 'Nghe An'},
                {value: 'Ninh Binh', label: 'Ninh Binh'},
                {value: 'Ninh Thuan', label: 'Ninh Thuan'},
                {value: 'Phu Tho', label: 'Phu Tho'},
                {value: 'Phu Yen', label: 'Phu Yen'},
                {value: 'Quang Binh', label: 'Quang Binh'},
                {value: 'Quang Nam', label: 'Quang Nam'},
                {value: 'Quang Ngai', label: 'Quang Ngai'},
                {value: 'Quang Ninh', label: 'Quang Ninh'},
                {value: 'Quang Tri', label: 'Quang Tri'},
                {value: 'Soc Trang', label: 'Soc Trang'},
                {value: 'Son La', label: 'Son La'},
                {value: 'Tay Ninh', label: 'Tay Ninh'},
                {value: 'Thai Binh', label: 'Thai Binh'},
                {value: 'Thai Nguyen', label: 'Thai Nguyen'},
                {value: 'Thanh Hoa', label: 'Thanh Hoa'},
                {value: 'Thua Thien Hue', label: 'Thua Thien Hue'},
                {value: 'Tien Giang', label: 'Tien Giang'},
                {value: 'Tra Vinh', label: 'Tra Vinh'},
                {value: 'Tuyen Quang', label: 'Tuyen Quang'},
                {value: 'Vinh Long', label: 'Vinh Long'},
                {value: 'Vinh Phuc', label: 'Vinh Phuc'},
                {value: 'Yen Bai', label: 'Yen Bai'},
            ],
            TH: [
                {value: 'Mae Hong Son', label: 'Mae Hong Son'},
                {value: 'Ratchaburi', label: 'Ratchaburi'},
                {value: 'Chiang Mai', label: 'Chiang Mai'},
                {value: 'Phetchaburi', label: 'Phetchaburi'},
                {value: 'Chiang Rai', label: 'Chiang Rai'},
                {value: 'Prachuap Khiri Khan', label: 'Prachuap Khiri Khan'},
                {value: 'Phayao', label: 'Phayao'},
                {value: 'Nan', label: 'Nan'},
                {value: 'Chai Nat', label: 'Chai Nat'},
                {value: 'Lamphun', label: 'Lamphun'},
                {value: 'Sing Buri', label: 'Sing Buri'},
                {value: 'Lampang', label: 'Lampang'},
                {value: 'Lop Buri', label: 'Lop Buri'},
                {value: 'Phrae', label: 'Phrae'},
                {value: 'Ang Thong', label: 'Ang Thong'},
                {value: 'Phra Nakhon Si Ayuttaya', label: 'Phra Nakhon Si Ayuttaya'},
                {value: 'Uttaradit', label: 'Uttaradit'},
                {value: 'Saraburi', label: 'Saraburi'},
                {value: 'Tak', label: 'Tak'},
                {value: 'Pathum Thani', label: 'Pathum Thani'},
                {value: 'Sukhothai', label: 'Sukhothai'},
                {value: 'Nonthaburi', label: 'Nonthaburi'},
                {value: 'Phitsanulok', label: 'Phitsanulok'},
                {value: 'Bangkok', label: 'Bangkok'},
                {value: 'Kamphaeng Phet', label: 'Kamphaeng Phet'},
                {value: 'Samut Prakan', label: 'Samut Prakan'},
                {value: 'Phichit', label: 'Phichit'},
                {value: 'Samut Songkhram', label: 'Samut Songkhram'},
                {value: 'Uthai Thani', label: 'Uthai Thani'},
                {value: 'Samut Sakhon', label: 'Samut Sakhon'},
                {value: 'Nakhon Sawan', label: 'Nakhon Sawan'},
                {value: 'Nakhon Pathom', label: 'Nakhon Pathom'},
                {value: 'Phetchabun', label: 'Phetchabun'},
                {value: 'Nakhon Nayok', label: 'Nakhon Nayok'},
                {value: 'Loei', label: 'Loei'},
                {value: 'Prachin Buri', label: 'Prachin Buri'},
                {value: 'Udon Thani', label: 'Udon Thani'},
                {value: 'Sa Kaew', label: 'Sa Kaew'},
                {value: 'Nongbua Lumphoo', label: 'Nongbua Lumphoo'},
                {value: 'Cha Choeng Sao', label: 'Cha Choeng Sao'},
                {value: 'Nong Khai', label: 'Nong Khai'},
                {value: 'Chon Buri', label: 'Chon Buri'},
                {value: 'Sakon Nakhon', label: 'Sakon Nakhon'},
                {value: 'Rayong', label: 'Rayong'},
                {value: 'Nakhon Phanom', label: 'Nakhon Phanom'},
                {value: 'Chanthaburi', label: 'Chanthaburi'},
                {value: 'Mukdahan', label: 'Mukdahan'},
                {value: 'Trat', label: 'Trat'},
                {value: 'Kalasin', label: 'Kalasin'},
                {value: 'Maha Sarakham', label: 'Maha Sarakham'},
                {value: 'Chumphon', label: 'Chumphon'},
                {value: 'Khon Kaen', label: 'Khon Kaen'},
                {value: 'Ranong', label: 'Ranong'},
                {value: 'Chaiyaphum', label: 'Chaiyaphum'},
                {value: 'Surat Thani', label: 'Surat Thani'},
                {value: 'Roi Et', label: 'Roi Et'},
                {value: 'Phang Nga', label: 'Phang Nga'},
                {value: 'Phuket', label: 'Phuket'},
                {value: 'Nakhon Ratchasima', label: 'Nakhon Ratchasima'},
                {value: 'Krabi', label: 'Krabi'},
                {value: 'Buri Ram', label: 'Buri Ram'},
                {value: 'Nakhon Si Thammarat', label: 'Nakhon Si Thammarat'},
                {value: 'Surin', label: 'Surin'},
                {value: 'Phatthalung', label: 'Phatthalung'},
                {value: 'Si Sa Ket', label: 'Si Sa Ket'},
                {value: 'Trang', label: 'Trang'},
                {value: 'Ubon Ratchathani', label: 'Ubon Ratchathani'},
                {value: 'Satun', label: 'Satun'},
                {value: 'Umnad Chareun', label: 'Umnad Chareun'},
                {value: 'Song Khla', label: 'Song Khla'},
                {value: 'Yasothon', label: 'Yasothon'},
                {value: 'Pattani', label: 'Pattani'},
                {value: 'Yala', label: 'Yala'},
                {value: 'Kanchanaburi', label: 'Kanchanaburi'},
                {value: 'Narathiwat', label: 'Narathiwat'},
                {value: 'Suphan Buri', label: 'Suphan Buri'},
            ]
        },
        userInfo: {
            id: null,
            uid: null,
            account: null,
            type: '制作员',
            clerkType: null,
            email: null,
            spareEmail: null,
            secret: null,
            confirmSecret: null,
            name: {
                firstName: null,
                lastName: null
            },
            sex: null,
            tel: {
                countryCode: null,
                areaCode: null,
                phoneNumber: null
            },
            fax: {
                countryCode: null,
                areaCode: null,
                phoneNumber: null
            },
            callPhone: null,
            safePhone: null,
            contactAddress: {
                country: null,
                province: null,
                city: null
            },
            streetAddress: null,
            postCode: null,
            dept: null,
            job: null,
            prodCount: 0,
            validateCode: null
        },
        errorMsg: {
            email: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入邮箱地址',
                formatError: '此邮箱暂不支持作为账户名，请更换'
            },
            spareEmail: {
                errMsg: {
                    type: null,
                    value: null
                },
                formatError: '此邮箱暂不支持作为账户名，请更换'
            },
            pwd: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入密码',
                minLength: '您的密码过短，请输入6到20个字符'
            },
            confirmPwd: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入密码',
                equals: '两次输入密码不一致，请再次输入密码'
            },
            name: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入姓名',
                formatError: '请输入英文字母，不能输入特殊字符'
            },
            sex: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须选择性别'
            },
            // 都放在一起判断了
            tel: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入电话号码',
                formatError: '只能输入数字'
                //formatError: '只能输入数字，连字符和空格'
                /*country: {
                    errMsg: {
                        type: null,
                        value: null
                    },
                    required: '必须输入电话号码国家区号',
                    formatError: '只能输入数字，连字符和空格'
                },
                areaCode: {
                    errMsg: {
                        type: null,
                        value: null
                    },
                    required: '必须输入电话号码地区区号',
                    formatError: '只能输入数字，连字符和空格'
                },
                phone: {
                    errMsg: {
                        type: null,
                        value: null
                    },
                    required: '必须输入电话号码',
                    formatError: '只能输入数字，逗号，连字符和空格'
                }*/
            },
            fax: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入电话号码',
                formatError: '只能输入数字'
                //formatError: '只能输入数字，连字符和空格'
                /*country: {
                    errMsg: {
                        type: null,
                        value: null
                    },
                    required: '必须输入电话号码国家区号',
                    formatError: '只能输入数字，连字符和空格'
                },
                areaCode: {
                    errMsg: {
                        type: null,
                        value: null
                    },
                    required: '必须输入电话号码地区区号',
                    formatError: '只能输入数字，连字符和空格'
                },
                phone: {
                    errMsg: {
                        type: null,
                        value: null
                    },
                    required: '必须输入电话号码',
                    formatError: '只能输入数字，逗号，连字符和空格'
                }*/
            },
            contactPhone: {
                errMsg: {
                    type: null,
                    value: null
                },
                formatError: '只能输入数字'
                //formatError: '只能输入数字，逗号，连字符和空格'
            },
            safePhone: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入安全手机号码',
                formatError: '只能输入数字'
                //formatError: '只能输入数字，逗号，连字符和空格'
            },
            contactAddress: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入地址'
            },
            streetAddress: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入地址'
            },
            postCode: {
                errMsg: {
                    type: null,
                    value: null
                },
                required: '必须输入邮编',
                formatError: '对不起，只允许输入英文字符，数字，空格或-，，/符号'
            },
            validateCode: {
                errMsg: {
                    type: null,
                    value: null
                },
                // required: '必须输入验证码',
                diffError: '验证码错误'
            }
        },
        subAccountNum: 0,
        ableAccountNum: 5
    };
    $scope.isAdd = true;
    $scope.showErr = false;
    $scope.f = {};

    // 省份的选择
    $scope.confirmProvinceList = null;

    // 生成验证码
    $scope.validateCode = null;

    var selectProvinceDom = null;
    var selectDeptDom = null;
    var VALIDATE_CODE_NUMBER = 4;
    var subAccountId = DSSX.util.queryString('subAccountId') || '';

    // =======================function===========================

    init();

    function init() {
        console.log('[sub-account-add init: ]');
        initVariable();
        initScopeWatch();
        initGetAccountNum();
        getSubAccountDetail();
    }

    function initGetAccountNum() {
        var url = '/usr/api/listSubAccount';
        request.get(url, {}, true).then(success, error);

        function success(res) {
            res = res || {};
            var subAccountsList = res.data.subAccounts || [];
            $scope.d.subAccountNum = subAccountsList.length;
            $scope.d.ableAccountNum -= $scope.d.subAccountNum;
            if (!subAccountId) {
                maxTip();
            }
        }

        function error(err) {
            DSSX.dialog.err(err, {
                moduleName: 'sub-account-add.js',
                funcName: 'initGetAccountNum',
                text: 'initGetAccountNum fail'
            });
        }

    }

    // 已达到最大数量提示
    function maxTip() {
        var num = $scope.d.subAccountNum;
        if (num < 5) {
            return;
        }
        $scope.showErr = true;
    }

    function initVariable() {
        selectProvinceDom = angular.element('#selectProvince');
        selectDeptDom = angular.element('#selectDept');
        $scope.d.userInfo.contactAddress.country = $scope.d.countryList[46];
        $scope.validateCode = randomValidateCode(VALIDATE_CODE_NUMBER);
        $scope.f = {
            updateValidateCode: updateValidateCode,
            updateSubAccount: updateSubAccount
        };
    }

    function initScopeWatch() {
        /**
         * 根据国家确定省份区间
         */
        $scope.$watch('d.userInfo.contactAddress.country', function (nv) {
            if (!nv) {
                return;
            }
            var selectCountryDom = angular.element('#selectCountry');

            switch (nv.value) {
                case 'CN':
                    $scope.confirmProvinceList = $scope.d.provinceMap.CN;
                    break;
                case 'KR':
                    $scope.confirmProvinceList = $scope.d.provinceMap.KR;
                    break;
                case 'US':
                    $scope.confirmProvinceList = $scope.d.provinceMap.US;
                    break;
                case 'UK':
                    $scope.confirmProvinceList = $scope.d.provinceMap.UK;
                    break;
                case 'IN':
                    $scope.confirmProvinceList = $scope.d.provinceMap.IN;
                    break;
                case 'TR':
                    $scope.confirmProvinceList = $scope.d.provinceMap.TR;
                    break;
                case 'MY':
                    $scope.confirmProvinceList = $scope.d.provinceMap.MY;
                    break;
                case 'VN':
                    $scope.confirmProvinceList = $scope.d.provinceMap.VN;
                    break;
                case 'TH':
                    $scope.confirmProvinceList = $scope.d.provinceMap.TH;
                    break;
                default:
                    $scope.confirmProvinceList = null;
                    break;
            }
            AdaptiveSelectDom($scope.d.userInfo.contactAddress.country.label, selectCountryDom);
        })

        $scope.$watch('d.userInfo.dept', function (nv) {
            if (!nv) {
                return;
            }
            AdaptiveSelectDom($scope.d.userInfo.dept.label, selectDeptDom);
        })

        selectProvinceDom.on('change', function () {
            $timeout(function () {
                AdaptiveSelectDom($scope.d.userInfo.contactAddress.province.label, selectProvinceDom);
            })
        })

    }

    /**
     * 加载编辑数据
     */
    function getSubAccountDetail() {
        var accountId = DSSX.util.queryString('subAccountId');

        if (!accountId) {
            return;
        }

        $scope.title = '编辑子账号';
        var sendUrl = '/usr/api/loadSubAccount?accountId=' + accountId;
        request.get(sendUrl, {}, false).then(success, error);

        function success(res) {
            res = res || {};
            $scope.d.userInfo = res.data.subAccount;
            $scope.d.userInfo.confirmSecret = $scope.d.userInfo.secret;
            $scope.d.userInfo.name.firstName = $scope.d.userInfo.name.firstName ? $scope.d.userInfo.name.firstName : '';
            $scope.d.userInfo.name.lastName = $scope.d.userInfo.name.lastName ? $scope.d.userInfo.name.lastName : '';
            $scope.d.userInfo.tel = $scope.d.userInfo.tel ? $scope.d.userInfo.tel : {countryCode: null, areaCode: null, phoneNumber: null}
            $scope.d.userInfo.fax = $scope.d.userInfo.fax ? $scope.d.userInfo.fax : {countryCode: null, areaCode: null, phoneNumber: null}
            $scope.d.userInfo.contactAddress = $scope.d.userInfo.contactAddress ? $scope.d.userInfo.contactAddress : {country: null, province: null, city: null}
            $scope.d.userInfo.validateCode = null;
            $scope.isAdd = false;

            var countryList = $scope.d.countryList;
            var deptList = $scope.d.departmentList;
            var provinceList = $scope.d.provinceMap;
            var contactAddress = $scope.d.userInfo.contactAddress || {};
            var country = contactAddress.country || '';
            var dept = $scope.d.userInfo.dept;
            var province = contactAddress.province || '';

            for (var i = 0, len = countryList.length; i < len; i += 1) {
                if (country === countryList[i].label) {
                    $scope.d.userInfo.contactAddress.country = countryList[i];
                }
            }
            for (var i = 0, len = deptList.length; i < len; i += 1) {
                if (dept === deptList[i].label) {
                    $scope.d.userInfo.dept = deptList[i];
                }
            }
            for (var prop in provinceList) {
                for (var i = 0, len = provinceList[prop].length; i < len; i += 1) {
                    if (province === provinceList[prop][i].label) {
                        $scope.d.userInfo.contactAddress.province = provinceList[prop][i];
                    }
                }
            }

        }

        function error(err) {
            DSSX.dialog.err(err, {
                moduleName: 'sub-account-add.js',
                funcName: 'getSubAccountDetail',
                text: 'getSubAccountDetail fail'
            });
        }

    }

    /**
     * select 框自适应
     */
    function AdaptiveSelectDom(text, elem) {
        if (!elem || elem.length <= 0) {
            return;
        }
        var tmp = document.createElement('span'); // 新建一个临时span来存储选项，然后获取选项的宽。
        tmp.innerHTML = text;
        tmp.style.visibility = "hidden";
        document.body.appendChild(tmp);
        var len = tmp.offsetWidth;
        elem[0].style.width = len + 20 + "px"; // 这里加20是考虑到那个箭头的宽度。
    }

    /**
     * Create Verification Code
     */
    function randomValidateCode(range) {
        range = range || 4;
        range = +('-' + range);
        return Math.random().toString(32).slice(range);
    }

    /**
     * 更换验证码
     */
    function updateValidateCode() {
        $scope.validateCode = randomValidateCode(VALIDATE_CODE_NUMBER);
    }

    /**
     * 表单校验
     * todo 再改
     */
    function checkUserInfo() {
        var checkResult = [];
        var reg1 = '[^(a-zA-Z)]'; // 只匹配英文 （用户名）
        var reg2 = '[^(0-9)]'; // 只匹配数字 空格 - （电话、传真、联系手机、安全手机）
        var reg3 = '[^(a-zA-z0-9- /)]'; // 只匹配英文 数字 空格 - / （邮编）

        var emailResult = checkEmail($scope.d.userInfo.email, $scope.d.errorMsg, 'email', false);
        var spareEmailResult = checkEmail($scope.d.userInfo.spareEmail, $scope.d.errorMsg, 'spareEmail', true);
        var pwdResult = checkPwd1();
        var confirmPwdResult = checkPwd2();

        var nameResult = checkFormData('name', 'name', [$scope.d.userInfo.name.firstName, $scope.d.userInfo.name.lastName], false, reg1);
        var sexResult = checkFormData('sex', 'sex', [$scope.d.userInfo.sex]);
        var telResult = checkFormData('tel', 'tel', [$scope.d.userInfo.tel.countryCode, $scope.d.userInfo.tel.areaCode, $scope.d.userInfo.tel.phoneNumber], false, reg2);
        var faxResult = checkFormData('fax', 'fax', [$scope.d.userInfo.fax.countryCode, $scope.d.userInfo.fax.areaCode, $scope.d.userInfo.fax.phoneNumber], true, reg2);
        var contactPhoneResult = checkFormData('contactPhone', 'contactPhone', [$scope.d.userInfo.callPhone], true, reg2);
        var safePhoneResult = checkFormData('safePhone', 'safePhone', [$scope.d.userInfo.safePhone], false, reg2);
        var contactAddressResult = checkFormData('contactAddress', 'contactAddress', [$scope.d.userInfo.contactAddress.country, $scope.d.userInfo.contactAddress.province, $scope.d.userInfo.contactAddress.city]);
        var streetAddressResult = checkFormData('streetAddress', 'streetAddress', [$scope.d.userInfo.streetAddress]);
        var postCodeResult = checkFormData('postCode', 'postCode', [$scope.d.userInfo.postCode], false, reg3);
        var validateCodeResult = checkValidateCode();

        checkResult.push(updateErrorMsg('email', emailResult));
        checkResult.push(updateErrorMsg('spareEmail', spareEmailResult));
        checkResult.push(updateErrorMsg('pwd', pwdResult));
        checkResult.push(updateErrorMsg('confirmPwd', confirmPwdResult));
        checkResult.push(updateErrorMsg('name', nameResult));
        checkResult.push(updateErrorMsg('sex', sexResult));
        checkResult.push(updateErrorMsg('tel', telResult));
        checkResult.push(updateErrorMsg('fax', faxResult));
        checkResult.push(updateErrorMsg('contactPhone', contactPhoneResult));
        checkResult.push(updateErrorMsg('safePhone', safePhoneResult));
        checkResult.push(updateErrorMsg('contactAddress', contactAddressResult));
        checkResult.push(updateErrorMsg('streetAddress', streetAddressResult));
        checkResult.push(updateErrorMsg('postCode', postCodeResult));
        checkResult.push(updateErrorMsg('validateCode', validateCodeResult));
        return checkResult;
    }

    // todo 有时间在重写尽量复用
    /**
     * email check
     */
    function checkEmail(email, emailErrorMsg, type, noCheckNull) {
        noCheckNull = noCheckNull || false;
        var errMsgObj = null;
        if (!email && !noCheckNull) {
            errMsgObj = {
                type: type,
                value: emailErrorMsg.email.required
            }
            return errMsgObj;
        }
        if (noCheckNull && !email) {
            return errMsgObj;
        }
        var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[.])+[A-Za-z]{2,5}$/;
        var result = reg.test(email);
        if (!result) {
            errMsgObj = {
                type: type,
                value: emailErrorMsg.email.formatError
            };
            return errMsgObj;
        }
        return errMsgObj;
    }

    /**
     * password check
     */
    function checkPwd1() {
        var pwd1 = $scope.d.userInfo.secret;
        var errMsgObj = null;
        if (!pwd1) {
            errMsgObj = {
                type: 'pwd',
                value: $scope.d.errorMsg.pwd.required
            };
            return errMsgObj;
        } else if (pwd1.length < 6) {
            errMsgObj = {
                type: 'pwd',
                value: $scope.d.errorMsg.pwd.minLength
            };
            return errMsgObj;
        }
        return errMsgObj;
    }

    function checkPwd2() {
        var pwd2 = $scope.d.userInfo.confirmSecret;
        var errMsgObj = null;
        if (!pwd2) {
            errMsgObj = {
                type: 'confirmPwd',
                value: $scope.d.errorMsg.confirmPwd.required
            };
            return errMsgObj;
        }
        if (pwd2 !== $scope.d.userInfo.secret) {
            errMsgObj = {
                type: 'confirmPwd',
                value: $scope.d.errorMsg.confirmPwd.equals
            };
            return errMsgObj;
        }
        return errMsgObj;
    }

    /**
     * single null check
     */
    function checkFormData(type, errorMsg, value, unCheckNull, reg) {
        unCheckNull = unCheckNull || false;
        var errMsgObj = unCheckNull ? unCheckN(value, reg, errorMsg) : checkNull(value, errorMsg);
        if (unCheckNull) {
            return errMsgObj;
        }
        if (!unCheckNull && errMsgObj) {
            return errMsgObj;
        }
        if (reg) {
            errMsgObj = re(reg, value, errorMsg);
        }

        // 检查null
        function checkNull(v, err) {
            var e = null;
            for (var i = 0, len = v.length; i < len; i += 1) {
                if (!v[i]) {
                    e = {
                        type: type,
                        value: $scope.d.errorMsg[err].required
                    };
                    return e;
                }
            }
            return e;
        }

        // 不检查null
        function unCheckN(v, regStr, err) {
            var nullResult = [];
            var e = null;
            angular.forEach(v, function (ele) {
                if (!ele) {
                    nullResult.push(false);
                } else {
                    nullResult.push(true);
                }
            })
            var r = nullResult.some(checkTrue);
            if (r) {
                e = re(regStr, v, err);
            }
            return e;
        }

        // 检查是否符合要求
        function re(regStr, v, errMsg) {
            var e = null;
            var result = [];
            var regExp = new RegExp(regStr, 'g');
            angular.forEach(v, function (ele) {
                result.push(regExp.test(ele));
            })
            var result1 = result.some(checkTrue);
            if (result1) {
                e = {
                    type: type,
                    value: $scope.d.errorMsg[errMsg].formatError
                };
                return e;
            }
            return null;
        }

        return errMsgObj;
    }

    /**
     * validate code check
     */
    function checkValidateCode() {
        var errMsgObj = null;
        var validateCode = $scope.d.userInfo.validateCode;
        if (validateCode !== $scope.validateCode) {
            errMsgObj = {
                type: 'validateCode',
                value: $scope.d.errorMsg.validateCode.diffError
            };
            return errMsgObj;
        }
        return errMsgObj;
    }

    /**
     * 更新错误提示
     */
    function updateErrorMsg(errType, errorMsg) {
        $scope.d.errorMsg[errType].errMsg = errorMsg;
        return !errorMsg;
    }

    /**
     * add sub account
     */
    function updateSubAccount() {
        var validateResult = checkUserInfo();
        var formResult = validateResult.every(checkTrue);
        if (formResult) {
            var array = handleUserInfo();
            var updateMethod = $scope.isAdd ? 'add' : 'modify';
            update(updateMethod, array);
        } else {
            layer.alert('您的信息填写格式有误，请重新填写！');
        }

        function handleUserInfo() {
            var arr = [];
            $scope.d.userInfo.contactAddress.country = $scope.d.userInfo.contactAddress.country.label;
            $scope.d.userInfo.contactAddress.province = $scope.d.userInfo.contactAddress.province.label || $scope.d.userInfo.contactAddress.province;
            if ($scope.d.userInfo.dept) {
                $scope.d.userInfo.dept = $scope.d.userInfo.dept.label;
            }
            $scope.d.userInfo.prodCount = $scope.d.userInfo.prodCount ? 1 : 0;

            $scope.d.userInfo.confirmSecret = undefined;
            $scope.d.userInfo.validateCode = undefined;
            delete $scope.d.userInfo.confirmSecret;
            delete $scope.d.userInfo.validateCode;

            arr.push($scope.d.userInfo);
            return arr;
        }

        function update(method, arr) {
            request.post('/usr/api/updateSubAccount', {method: method}, arr, true)
                .then(success, error)
                .then(accountTMInterpolator)
            ;

            function success(res) {
                var title = $scope.isAdd ? '添加子账号成功' : '修改子账号成功';
                layer.open({
                    title: title,
                    closeBtn: 0,
                    content: '<a href="sub-account-manage.html">返回子账号管理页面</a>',
                    btn: ['确定'],
                    yes: function () {
                        window.location.href = 'sub-account-manage.html';
                    }
                })

                var id = DSSX.util.safe(res, 'data.ids.0', '');

                return {
                    bindId: subAccountId || id,
                    bindInfo: subAccountId || id
                };
            }

            function error(err) {
                var code = DSSX.util.safe(err, 'data.data.code', -1);
                if (code === 5) {
                    layer.alert('您的子账号数量已达到5个，无法继续添加！');
                    return;
                }

                DSSX.dialog.err(err, {
                    moduleName: 'sub-account-add.js',
                    funcName: 'addSubAccount',
                    text: 'addSubAccount fail'
                });
                return $q.reject(err);
            }
        }
    }

    function checkTrue(d) {
        return !!d;
    }

    function accountTMInterpolator(option) {
        var TM = DSSX.TrainingMission;

        return TM.tryStart(TM.MissionType.SiteManage_SubAccount, {bindId: option.bindId, bindInfo: option.bindInfo})
            .then(tryStartTMSuc, tryStartTMErr);

        function tryStartTMSuc(tmc) {

        }

        function tryStartTMErr(err) {
            console.log('[addSubAccountCtrl] accountTMInterpolatorErr', err);
        }
    }
}